import React, { Fragment } from 'react';
import HourlySalesReportView from './HourlySalesReportView';

// Thin route entry — the V3 shell lives inside the view.
const HourlySalesReport = () => (
    <Fragment>
        <HourlySalesReportView />
    </Fragment>
);

export default HourlySalesReport;
